import bookBundling from '@/assets/store/images/book-bundling.png';
import CoverHome from '@/assets/store/images/vertical-book.png';


import book1Front from '@/assets/store/images/book-1.png';
import book1Back from '@/assets/store/images/book-1.png';

import book2Front from '@/assets/store/images/book-2.png';
import book2Back from '@/assets/store/images/book-2.png';

import book3Front from '@/assets/store/images/book-3.png';
import book3Back from '@/assets/store/images/book-4.png';

import book4Front from '@/assets/store/images/book-5.png';
import book4Back from '@/assets/store/images/book-5.png';
import type { NEWCOLOR_PALETTE } from '@/store/colorStore';

export interface BookProduct {
  id: number;
  title: string;
  frontCover: string;
  backCover?: string;
  author: string;
  category: string;
  price: number;
  weight: string;
  length?: string;
  width?: string;
  isbn: string;
  description: string;
}



export const BOOKS_DATA: BookProduct[] = [
  {
    id: 1,
    title: 'Biji dandelion, terbang melayang!',
    frontCover: book1Front,
    backCover: book1Back,
    author: 'Jin Mi-Ok',
    category: 'Tumbuhan',
    price: 259900,
    weight: '400-450g',
    isbn: '979-11-221489-0-9',
    description:
      'Nasi dan kue tradisional yang kita makan, serta buah-buahan yang manis dan segar, semuanya berasal dari tumbuhan, lho!',
  },
  {
    id: 2,
    title: 'Lebah kecil jumpa bunga stroberi',
    frontCover: book2Front,
    backCover: book2Back,
    author: 'Lee Ru-Mi',
    category: 'Tumbuhan',
    price: 259900,
    weight: '400-450g',
    isbn: '979-11-221489-1-6',
    description:
      'Bunga Forsythia yang kuning cerah dan Mawar merah yang cantik memamerkan warna indah.',
  },
  {
    id: 3,
    title: 'Biji Kecil, terbang jauh.',
    frontCover: book3Front,
    backCover: book3Back,
    author: 'Cha Su-Jin',
    category: 'Tumbuhan',
    price: 259900,
    weight: '400-450g',
    isbn: '979-11-221489-2-3',
    description:
      'Bunga pacar air menyebarkan bijinya dengan meletuskan polongnya.',
  },
  {
    id: 4,
    title: 'Petualangan Ulang Tahun Dochi',
    frontCover: book4Front,
    backCover: book4Back,
    author: 'Choi Seo-Yeon',
    category: 'Hewan',
    price: 259900,
    weight: '400-450g',
    isbn: '979-11-221489-3-0',
    description:
      'Ada hewan-hewan yang memberi makan bayinya dengan susu. Singa, monyet, gajah, kelelawar, dan banyak lagi.',
  },
];



export interface BookBundling {
    id: number;
    title: string;
    frontCover: string;
    bookBudling: string;
    category: string;
    discount?: number;
    price: number;
    weight: string;
    isbn: string;
    description: string;
}

export const BOOK_BUNDLING_DATA: BookBundling[] = [
    {
    id: 1,
    title: 'Paket Bundling - 30 Buku Anak-Anak Lengkap',
    frontCover: bookBundling,
    bookBudling: CoverHome,
    category: 'semua Kategory',
    price: 259900,
    discount: 12000,
    weight: '400-450g',
    isbn: '-',
    description:
        'Paket Bundling Buku Anak - Temukan keajaiban dalam setiap halaman! Paket ini mencakup berbagai judul menarik yang dirancang khusus untuk anak-anak. Dalam koleksi ini, Anda akan menemukan buku-buku yang mengajarkan nilai-nilai penting seperti persahabatan, keberanian, dan rasa ingin tahu. Setiap kategori buku menawarkan petualangan yang berbeda, mulai dari cerita fantasi hingga pengetahuan tentang alam. Dengan paket ini, anak-anak dapat menjelajahi dunia imajinasi dan belajar sambil bersenang-senang. Berikut adalah daftar buku per kategori:',
    },

]




export const AVAILABILITY_STATUS = {
    preOrder: {
        label: 'Pre-Order',
        color: '#135A78',
        bg: 'softBlue',
    },
    ready: {
        label: 'Tersedia',
        color: '#00C483',
        bg: 'greenLight',
    },
} 

export type list_availability_status = keyof typeof AVAILABILITY_STATUS;

